import React, { useContext } from "react";
import { DiscoveryContext } from "../discovery-context";
import ReTableView from "../../Dashboard/common/ReTableView"
import { transformSourcesResponse,transformOldSourcesResponse } from "../../../utils/helpers"
import { downloadExcelV2, prepareSourceDataForExcel } from "../../../utils/monitoring-helpers";
import { Button } from "@mui/material";
import classes from "./Sources.module.css";

function filterUniqueDomains(urls) {
  const domainMap = new Map();

  urls.forEach((url) => {
    try {
      const parsedUrl = new URL(url);
      const fullDomain = parsedUrl.hostname;
      const parts = fullDomain.split(".");
      const mainDomain = parts.slice(-2).join(".");

      if (!domainMap.has(mainDomain)) {
        domainMap.set(mainDomain, { src: fullDomain, items: [], urls: [] });
      }

      const domainEntry = domainMap.get(mainDomain);

      if (!domainEntry.urls.includes(url)) {
        domainEntry.urls.push(url);
      }

      if (
        fullDomain !== mainDomain &&
        !domainEntry.items.some((item) => item.src === fullDomain)
      ) {
        domainEntry.items.push({ src: fullDomain, urls: [url] });
      } else {
        const subdomainEntry = domainEntry.items.find(
          (item) => item.src === fullDomain
        );
        if (subdomainEntry && !subdomainEntry.urls.includes(url)) {
          subdomainEntry.urls.push(url);
        }
      }
    } catch (error) {
      console.error("Invalid URL:", url);
    }
  });

  return Array.from(domainMap.values()).map((domain) => ({
    src: domain.src,
    urls: domain.urls,
    ...(domain.items.length > 0 ? { items: domain.items } : {}),
  }));
}

export default function Sources() {
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryType = discoveryCtx.type || "brand";
  const sources = discoveryCtx?.sources ?? [];
  const category = discoveryCtx.category;
  const llm = discoveryCtx.llm;
  const market = discoveryCtx.market;
  const sourcesData = {};
  const showOldSourcesRecord = discoveryCtx.state.sourceValidationStatus === "PENDING";
  let data;
  const selectedInput = {
    brand: discoveryCtx.entity,
    category,
    // geography: market,
    llm,
    market,
    // persona: "General Persona",
    product: discoveryCtx.type == "product" ? true : false,
  }
  const labelMapping = {
    LLM: "llm",
  }
  const sourceFilter = {
    value: "LLM",
    label: "Compare by LLM"
  }

  if (!sourcesData[llm]) sourcesData[llm] = {};
  if (!sourcesData[llm][category]) sourcesData[llm][category] = {};
  if (!sourcesData[llm][category][market]) sourcesData[llm][category][market] = {};

  sourcesData[llm][category][market] = sources;
if(showOldSourcesRecord){
   data = transformOldSourcesResponse(sourcesData, [discoveryCtx.llm], category, market);
}else{
   data = transformSourcesResponse(sourcesData, [discoveryCtx.llm], category, market);
}
console.log("ValidationData",showOldSourcesRecord,data,sourcesData,sources)
  const isSourceValidating =
    discoveryCtx.state?.sourceValidationStatus === "RUNNING" &&
    ["COMPLETED", "RETRY"].includes(discoveryCtx.state?.transactionStatus);
  return (
    <>
      <Button
        onClick={() => {
          const preparedData = prepareSourceDataForExcel(data, selectedInput, labelMapping, sourceFilter);
          downloadExcelV2(preparedData, labelMapping[sourceFilter?.value]);
        }}
      >
        Export
      </Button>
      {isSourceValidating &&
        <div className={classes.validationMessage}>
          <div>
            <span style={{ fontSize: "18px", marginRight: "8px" }}>⏳</span>
            Source validation is still in progress
          </div>
        </div>
      }
      <ReTableView
        type={`${discoveryType === "brand" ? "Brand" : "Product"}`}
        data={data}
        isValidated={!showOldSourcesRecord}
        isOverview = {true}
      />
    </>
  );
}
